import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './app/App';
import store from './app/store';
import { Provider } from 'react-redux';
import * as serviceWorker from './serviceWorker';
import {restoreSession} from "./features/auth/authSlice";
import {BrowserRouter as Router} from "react-router-dom";
import Modal from "react-modal";
import TagManager from 'react-gtm-module'

const tagManagerArgs = {
    gtmId: 'GTM-MDTQV7J'
}

TagManager.initialize(tagManagerArgs)

store.dispatch(restoreSession());

const appElementId = 'root';

Modal.setAppElement(`#${appElementId}`)

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <Router>
        <App />
      </Router>
    </Provider>
  </React.StrictMode>,
  document.getElementById(appElementId),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
